'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../styleInject.js');

var css_248z = ".StickyFooter-module_footerWrapper__hM79l{width:100%}.StickyFooter-module_footerWrapperNoPadding__s-OLe footer>nav{padding:0}.StickyFooter-module_absoluteContainer__XnlzN{position:absolute}.StickyFooter-module_stickyContainer__1WrYZ{position:fixed}";
var styles = {"footerWrapper":"StickyFooter-module_footerWrapper__hM79l","footerWrapperNoPadding":"StickyFooter-module_footerWrapperNoPadding__s-OLe","absoluteContainer":"StickyFooter-module_absoluteContainer__XnlzN","stickyContainer":"StickyFooter-module_stickyContainer__1WrYZ"};
styleInject["default"](css_248z, 'a78e7abe-2100-4341-8105-dc204048755a');

exports["default"] = styles;
